import React, { useEffect } from 'react'
import { Breadcrumb, Container, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { fetchSingleSaloon } from '../../../redux/action/saloons/single-saloon'
import default_image_url from '../../../redux/api/API'
import MainLoading from '../../../utils/MainLoading'
import HomeMainTitle from '../../homeTitle/HomeMainTitle'
import Wrapper from '../../homeWrapper/Wrapper'
import {FaEye} from 'react-icons/fa'
import './style.scss'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

const Saloon = (props) => {
    const dispatch = useDispatch()
    const saloon = useSelector(state => state.singleSaloon)
    const {t} = useTranslation();

    useEffect(() => {
        dispatch(fetchSingleSaloon(props.match.params.id))
    }, [props.match.params.id])


    return (
        <Wrapper>
            {saloon.loading ? 
                <MainLoading />
            :   
                saloon.single_saloon ? 
                    <Container>
                        <Breadcrumb className='saloon_breadcrumb my-4'>
                            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/saloons" }} >{t("halls")}</Breadcrumb.Item>
                            <Breadcrumb.Item active>{saloon.single_saloon.name}</Breadcrumb.Item>
                        </Breadcrumb>
                        <Helmet>
                            <title>{`${saloon.single_saloon.name} - نمایشگاه مجازی`}</title>
                        </Helmet>
                        <div className='animate__animated animate__fadeInDown'>
                            <HomeMainTitle>{saloon.single_saloon.name}</HomeMainTitle>
                            <Row className='saloons_page_items'>
                                {saloon.single_saloon.users && 
                                    saloon.single_saloon.users.length ? 
                                        saloon.single_saloon.users.map(saloon => (
                                            <div className='col-lg-3 company_item' key={saloon.id} >
                                                <Link to={`/company/${saloon.id}`}>
                                                    {saloon.avatar ?
                                                        <img src={default_image_url+saloon.avatar} alt="company" />
                                                    :
                                                        <img src='/assets/img/salon_icon.png' alt="company" />
                                                    }
                                                    <h1> {saloon.title} </h1>
                                                    <div className='company_card_items'>
                                                        <div className='company_card_item'><h6>{t("CEO name")} : </h6><h5> {saloon.manager_name} </h5></div>
                                                        <div className='company_card_item'><h6>{t("location")} : </h6><h5>{saloon.province ? saloon.province+'، '+saloon.city : '-' }</h5></div>
                                                    </div>
                                                    <div className='company_card_footer'>
                                                        <div className='company_card_footer_item'><FaEye /><h5>{saloon.view_count} {t("visit")}</h5></div>
                                                    </div>
                                                </Link>  
                                            </div>
                                        ))
                                    :
                                        <h6 className='text-center'> برای این سالن، غرفه‌ای ایجاد نشده است </h6>
                                }
                            </Row>
                        </div>
                    </Container>
                :
                    <Redirect to='/404' />
            }
        </Wrapper>
    )
}

export default Saloon
